<template>
  <a-modal
    :title="title"
    :width="1280"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    :footer="null"
    :bodyStyle="{ height: '700px', overflowY: 'auto' }"
    @cancel="() => { $emit('cancel') }"
  >
    <div>
      <a-spin :spinning="loading">
        <a-form :form="form" :layout="formLayout">
          <a-row>
            <a-col :span="24">
              <a-divider orientation="left">
                基础信息
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="系统编号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.data['number'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="合同号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.data['contract_number'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="合同名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.data['name'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="贸易类型" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.tradeTypes[this.data['trade_type']] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="签订日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.data['contract_date'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="data['type'] === 1 ? '供应商':'客户'" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.clientList.filter(item => this.data['client_ids'].includes(item.client_id)).map(item => item.client).join(',') }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="产品名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.data['product_name'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.data['count'] }}
                {{ this.$Dictionaries.unit[this.data['unit']] }}
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="this.data['trade_type'] !== 1">
              <a-form-item label="贸易术语" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.data['trade_term'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="交货地" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.data['delivery_address'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="最迟交货日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.data['latest_delivery_date'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="溢装率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.data['overloading_rate'] }} %
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="短装率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.data['shortage_rate'] }} %
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                财务信息
              </a-divider>
            </a-col>
            <a-col :span="12" v-if="data['type'] === 1">
              <a-form-item label="关税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.data['tariff'] }} {{ this.data['tariff_type'] === 1 ? '%' : '' }}
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="data['type'] === 1">
              <a-form-item label="消费税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.data['consumption_tax'] }} {{ this.data['consumption_tax_type'] === 1 ? '%' : '' }}
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="data['type'] !== undefined">
              <a-form-item label="增值税率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.data['tax_rate'] }}%
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                商品信息
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="规格型号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.data['spec'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="this.data['trade_type'] !== 1">
              <a-form-item label="HSCode" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.data['customs_declaration_code'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="质量扣款依据" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.data['quality_deduction_reason'] }}
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="质量" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                <a-table
                  bordered
                  :data-source="otherData.product_parameters"
                  :columns="parameterColumns"
                  v-if="this.otherData.product_parameters.length > 0"
                  :pagination="false"
                  key="key">
                  <span slot="serial" slot-scope="text, record, index">
                    {{ index + 1 }}
                  </span>
                </a-table>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                金额信息
              </a-divider>
            </a-col>
            <a-col :span="24">
              <a-form-item label="定价方式" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                {{ this.$Dictionaries.unit_price_type[this.data['unit_price_type']] }}
              </a-form-item>
            </a-col>
            <a-col :offset="2" :span="22" v-if="selectedUnitPrice === 1">
              <a-divider orientation="left" dashed>固定定价</a-divider>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="计价币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.$Dictionaries.currency[this.data['pricing_currency']] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="收款币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.$Dictionaries.currency[this.data['receive_pricing_currency']] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="单价" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['unit_price'] }}
                    {{ this.$Dictionaries.currency[this.pricingCurrency] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="单价是否含税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['is_tax_unit_price'] ? '是' : '否' }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="汇率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['exchange_rate'] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['pricing_count'] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="合同金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['contract_amount'] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="合同金额是否含税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['is_tax_contract_amount'] ? '是' : '否' }}
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>
            <a-col :offset="2" :span="22" v-if="selectedUnitPrice === 2">
              <a-divider orientation="left" dashed>点价定价</a-divider>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="计价币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.$Dictionaries.currency[this.data['pricing_currency']] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="收款币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.$Dictionaries.currency[this.data['receive_pricing_currency']] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="升贴水" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['premium_discount'] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="点价费" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['price_fixing_fee'] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="定价源" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['pricing_source'] }}
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-row>
                    <a-col :offset="2" :span="22" v-if="otherData.turning_month_list.length > 0 || isTurningMonth">
                      <a-table
                        style="width: 80%"
                        :data-source="otherData.turning_month_list"
                        ref="turningMonthTable"
                        :columns="turningMonthColumns"
                        :pagination="false">
                        <span slot="serial" slot-scope="text, record, index">
                          {{ index + 1 }}
                        </span>
                      </a-table>
                    </a-col>
                  </a-row>
                </a-col>
                <a-col :span="24">
                  <a-form-item label="汇率" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                    {{ this.$Dictionaries.exchange_rate[this.data['exchange_rate_type']] }}
                  </a-form-item>
                </a-col>
                <a-col :span="24" v-if="selectedExchangeRate > 0">
                  <!--                  <a-divider orientation="left" dashed>{{ exchangeRateTitle }}</a-divider>-->
                  <a-form-item label="固定汇率" v-if="selectedExchangeRate === 1" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                    {{ this.data['fixed_exchange_rate'] }}
                  </a-form-item>
                  <a-row v-if="selectedExchangeRate === 2">
                    <a-col :span="12">
                      <a-form-item label="日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                        {{ this.data['fixed_date_rate'] }}
                      </a-form-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item label="汇率定义方式" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                        {{ this.data['exchange_rate_definition'] }}
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-form-item label="其他日期汇率" v-if="selectedExchangeRate === 3" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                    {{ this.data['unfixed_date_rate'] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="单价" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['unit_price'] }}
                    {{ this.$Dictionaries.currency[this.pricingCurrency] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="单价是否含税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['is_tax_unit_price'] ? '是' : '否' }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="临时汇率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['temp_exchange_rate'] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['pricing_count'] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="合同金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['contract_amount'] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="合同金额是否含税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['is_tax_contract_amount'] ? '是' : '否' }}
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>
            <a-col :offset="2" :span="22" v-if="selectedUnitPrice === 3">
              <a-divider orientation="left" dashed>浮动定价</a-divider>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="PACE指数月份" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['pace_date'] && this.data['pace_date'].substring(0, this.data['pace_date'].lastIndexOf('-')) }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="升贴水" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['premium_discount'] }}
                    <span style="padding-left: 10px">正数为升水、负数为贴水</span>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="计价币种" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['pricing_currency'] && this.$Dictionaries.currency[this.data['pricing_currency']] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="汇率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['exchange_rate'] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="数量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['pricing_count'] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="合同金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['contract_amount'] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="合同金额是否含税" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['is_tax_contract_amount'] ? '是' : '否' }}
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                付款方式
              </a-divider>
            </a-col>
            <a-col :span="24">
              <a-form-item label="预付款方式" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                {{ this.data['payment_method'] && this.$Dictionaries.trade_pre_payment_method[this.data['payment_method']] }}
              </a-form-item>
            </a-col>
            <a-col :offset="2" :span="20" class="hidden_item" v-if="paymentMethod > 0">
              <a-divider orientation="left" dashed>{{ paymentMethodTitle }}</a-divider>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="预付款金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['pre_payment'] }}
                    <span style="padding-left: 5px">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
                  </a-form-item>
                </a-col>
                <a-col :span="12" v-if="this.data['pre_payment'] >0 && this.data['pre_payment_date'] !== '1970-01-01'">
                  <a-form-item label="预付款支付期限" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['pre_payment_date'] }}
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>
            <a-col :span="24" v-if="false">
              <a-form-item label="尾款方式" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                {{ this.data['balance_payment_method'] && this.$Dictionaries.trade_balance_payment_method[this.data['balance_payment_method']] }}
              </a-form-item>
            </a-col>
            <a-col :offset="2" :span="20" class="hidden_item" v-if="balancePaymentMethod > 0 && balancePaymentMethod !== 6 && false">
              <a-divider orientation="left" dashed>{{ balancePaymentMethodTitle }}</a-divider>
              <a-row>
                <a-col :span="12">
                  <a-form-item label="尾款金额" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['balance_payment'] }}
                    <span style="padding-left: 5px">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
                  </a-form-item>
                </a-col>
                <a-col :span="12" v-if="this.data['balance_payment'] > 0">
                  <a-form-item label="尾款支付期限" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['trade_balance_payment_date_method'] && this.$Dictionaries.trade_balance_payment_date_method[this.data['trade_balance_payment_date_method']] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12" v-if="tradeBalancePaymentTimeMethod === 1 && this.data['balance_payment_date'] !== '1970-01-01'">
                  <a-form-item label="确定尾款日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['balance_payment_date'] }}
                  </a-form-item>
                </a-col>
                <a-col :span="12" v-else-if="tradeBalancePaymentTimeMethod === 2">
                  <a-form-item label="承兑日后" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['trade_balance_payment_days'] }} （天）
                  </a-form-item>
                </a-col>
                <a-col :span="12" v-else-if="tradeBalancePaymentTimeMethod === 3">
                  <a-form-item label="不确定尾款日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                    {{ this.data['unbalance_payment_date_desc'] }}
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                货转信息
              </a-divider>
            </a-col>
            <a-col :span="12">
              <a-form-item label="备案仓库" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <span v-if="this.tradeWarehouseList.length > 0">{{ this.tradeWarehouseList.filter(item => item.id === this.data['warehouse_id']).map(item => item.name + '(' + item.location + ')')[0] }}</span>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="入库货转类型" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                {{ this.$Dictionaries.trade_warehouse_stock_transfer_types[this.data['warehouse_stock_transfer_type']] }}
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="stockTransferType === 1">
              <a-form-item label="货转前提条件" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.$Dictionaries.trade_sell_contract_goods_transfer_prerequisites[this.data['goods_transfer_prerequisity']] }}
                <span v-if="goodsTransferPrerequisity >= 1">
                  {{ this.data['postpone_days'] }}
                  {{ this.data['postpone_days_type'] === 2 ? '工作日' : '天' }}
                </span>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="stockTransferType === 2">
              <a-form-item label="货转后约束条件" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                {{ this.data['constraints'] }}
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="提货期" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                {{ this.$Dictionaries.trade_delivery_period_types[this.data['delivery_period_type']] }}
                <span v-if="deliveryPeriodType !== 6 && deliveryPeriodType > 0">
                  {{ this.data['delivery_period_postpone_days'] }}
                  {{ this.data['delivery_period_postpone_days_type'] === 2 ? '工作日' : '天' }}
                  内提完
                </span>
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="deliveryPeriodType !== 6 && deliveryPeriodType > 0">
              <a-form-item label="超期责任人" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
                <span v-if="this.clientList && this.clientList.filter(item => item.client_id === this.data['undertaking_party_id'])[0]">
                  {{ this.clientList.filter(item => item.client_id === this.data['undertaking_party_id'])[0].client }}
                </span>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                结算信息
              </a-divider>
            </a-col>
            <a-col :span="24">
              <a-form-item label="结算量" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                {{ this.settlementVolumeList[this.data['settlement_volume']] }}
              </a-form-item>
            </a-col>
            <a-col :span="24" v-if="settlementVolumeContent !== undefined && settlementVolumeContent.length > 0">
              <a-form-item label="结算量内容" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                <a-tag v-for="(value, key) in settlementVolumeContent" :key="key" >{{ value }}</a-tag>
              </a-form-item>
            </a-col>
            <a-col :span="24" v-if="settlementVolumeContent !== undefined && settlementVolumeContent.length === 0 && settlementVolume === 5">
              <a-form-item label="结算量名称" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                {{ this.data['custom_settlement_volume'] }}
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-divider orientation="left">
                附件信息
              </a-divider>
            </a-col>
            <a-col :span="24">
              <a-form-item label="合同附件" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
                <a-table
                  bordered
                  :data-source="otherData.attachment"
                  :columns="attachmentColumns"
                  v-if="this.otherData.attachment.length > 0"
                  :pagination="false"
                  key="key">
                  <span slot="action" slot-scope="text, record">
                    <template>
                      <a :href="record.url" target="_blank">预览</a>
                    </template>
                  </span>
                </a-table>
                <span v-else>无</span>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <component
          :ref="currentComponent"
          @cancel="handleAddCancel"
          @ok="handleOk"
          :record="mdl"
          :is="currentComponent"
          :visible="visibleFrom"
          v-if="visibleFrom"
          :loading="confirmLoadingFrom"
          :model="mdl"></component>
      </a-spin>
    </div>
  </a-modal>
</template>

<script>
import {
  sell_contract_list,
  sell_contract_fixed_pricing_list,
  sell_contract_point_pricing_list,
  sell_contract_floating_pricing_list
} from '@/api/trade_sell_contract'
import { project_client_list } from '@/api/trade_project_client'
import UnitPriceForm from '../modules/UnitPriceForm'
import ExchangeRateForm from '../modules/ExchangeRateForm'
import PaymentMethodForm from '../modules/PaymentMethodForm'
import TurningMonthForm from '../modules/TurningMonthForm'
import AttachmentCreateForm from '../attachment/modules/CreateForm'
import CreateProductParameterForm from '../../product_parameter/modules/CreateForm'
import { warehouse_list } from '@/api/trade_warehouse'
import { sell_contract_attachment_list } from '@/api/trade_sell_contract_attachment'

export default {
  name: 'TableEdit',
  components: {
    UnitPriceForm,
    ExchangeRateForm,
    PaymentMethodForm,
    AttachmentCreateForm,
    TurningMonthForm,
    CreateProductParameterForm
  },
  props: {
    model: {
      type: Object,
      default: () => null
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      futuresContractFirstId: 0,
      futuresSellContractFirstId: 0,
      data: {},
      formLayout: 'horizontal',
      mdl: {},
      selectedUnitPrice: 0,
      selectedExchangeRate: 0,
      isSelectedTempUnitPrice: 0, // 是否有临时单价
      isSelectedTempExchangeRate: 0, // 是否有临时汇率
      isSelectedTempContractAmount: 0, // 是否有临时合同金额
      paymentMethod: 0, // 支付方式
      balancePaymentMethod: 0, // 支付方式
      tradeBalancePaymentTimeMethod: 0, // 支付方式
      prePayment: 0, // 预付款
      balancePayment: 0, // 预付款
      pricingCurrency: undefined, // 计价币种
      receivePricingCurrency: undefined, // 收款币种
      tradeTypes: this.$Dictionaries.trade_types,
      currentComponent: '',
      loading: false,
      visibleFrom: false,
      confirmLoadingFrom: false,
      warehouseFetching: false,
      tradeWarehouseList: [],
      stockTransferType: 0, // 入库货转类型
      goodsTransferPrerequisity: 0, // 货转前提条件
      deliveryPeriodType: 0, // 提货期
      settlementVolume: 0,
      settlementVolumeList: this.$Dictionaries.trade_settlement_volume,
      settlementVolumeContent: undefined,
      custom_settlement_volume_content: undefined,
      customSettlementVolumeContent: [],
      settlementVolumeVisible: false,
      isTurningMonth: false,
      otherData: {
        key_point: [],
        attachment: [],
        turning_month_list: [],
        product_parameters: []
      },
      clientList: [],
      turningMonthColumns: [
        {
          title: '序号',
          width: 80,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '期货合约',
          dataIndex: 'futures_contract',
          width: 150,
          align: 'center',
          ellipsis: true,
          customRender: (text) => text.substring(0, text.lastIndexOf('-'))
        },
        {
          title: '默认计价期',
          dataIndex: 'pricing_period_start_date',
          ellipsis: true,
          width: 200,
          align: 'center',
          customRender: (text, obj) => text + '~' + obj.pricing_period_end_date
        },
        {
          title: '锁价期限',
          dataIndex: 'lock_up_date',
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          title: '是否转月',
          dataIndex: 'is_turning_month',
          ellipsis: true,
          align: 'center',
          customRender: (text) => text ? '是' : '否'
        },
        {
          title: '转月费',
          dataIndex: 'monthly_transfer_fee',
          ellipsis: true,
          align: 'center',
          customRender: (text, record) => record['is_turning_month'] ? this.data['monthly_transfer_fee'] : 0
        }
      ],
      attachmentColumns: [
        {
          title: '名称',
          dataIndex: 'name',
          width: 300
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 100,
          scopedSlots: { customRender: 'action' }
        }
      ],
      parameterColumns: [
        {
          title: '序号',
          width: 50,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '名称',
          dataIndex: 'name',
          width: 200,
          ellipsis: true
        },
        {
          title: '符号',
          dataIndex: 'symbol',
          width: 160,
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.trade_value_compare_symbol[text] || '无'
        },
        {
          title: '值',
          dataIndex: 'standard_value',
          width: 160,
          ellipsis: true
        }
      ]
    }
  },
  mounted () {
    this.loadContract()
    this.loadContractAttachment()
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 18 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 3 },
          wrapperCol: { span: 21 }
        } : {}
    },
    title () {
      if (this.model['type'] === 1) {
        return '采购合同预览'
      } else {
        return '销售合同预览'
      }
    },
    exchangeRateTitle () {
      if (this.selectedExchangeRate === 1) {
        return '汇率-固定汇率'
      } else if (this.selectedExchangeRate === 2) {
        return '汇率-日期'
      } else if (this.selectedExchangeRate === 3) {
        return '汇率-其他日期汇率'
      }
      return ''
    },
    paymentMethodTitle () {
      if (this.paymentMethod > 0) {
        return '预付款支付-' + (this.$Dictionaries.trade_pre_payment_method[this.paymentMethod] || '')
      }
      return ''
    },
    balancePaymentMethodTitle () {
      if (this.balancePaymentMethod > 0) {
        return '尾款支付-' + (this.$Dictionaries.trade_balance_payment_method[this.paymentMethod] || '')
      }
      return ''
    },
    balancePaymentMethodKeys () {
      return Object.keys(this.$Dictionaries.trade_balance_payment_method).map(item => Number(item))
    }
  },
  methods: {
    loadContract () {
      this.loading = true
      sell_contract_list({ id: this.model['id'] })
        .then(res => {
          console.log(res.data, '我是数据列表@')
          const list = res.data.entries
          if (list && list.length > 0) {
            this.data = list[0]
            this.loadTransferInfo(this.data)
            this.loadSettlementInfo(this.data)
            // this.loadEditInfo(this.data)
            this.handleClientSearch(undefined)
            this.loadPricingByType(this.data)
          }
        }).finally(() => {
          setTimeout(() => {
            this.loading = false
          }, 3000)
      })
    },
    loadTransferInfo (data) {
      // 货转信息
      const transferInfo = data.transfer_info
      this.stockTransferType = transferInfo.warehouse_stock_transfer_type
      if (this.stockTransferType === 1) {
        this.goodsTransferPrerequisity = transferInfo.goods_transfer_prerequisity
      }
      this.data.warehouse_id = transferInfo.warehouse_id
      if (transferInfo.warehouse_stock_transfer_type) {
        this.data.warehouse_stock_transfer_type = transferInfo.warehouse_stock_transfer_type + ''
      }
      this.data.goods_transfer_prerequisity = transferInfo.goods_transfer_prerequisity + ''
      if (transferInfo.delivery_period_type) {
        this.data.delivery_period_type = transferInfo.delivery_period_type + ''
        this.deliveryPeriodType = transferInfo.delivery_period_type
        this.data.delivery_period_postpone_days = transferInfo.delivery_period_postpone_days
        this.data.delivery_period_postpone_days_type = transferInfo.delivery_period_postpone_days_type + ''
        this.data.undertaking_party_id = transferInfo.undertaking_party_id
      }
      this.data.postpone_days = transferInfo.postpone_days
      this.data.postpone_days_type = transferInfo.postpone_days_type + ''
      this.data.constraints = transferInfo.constraints
      this.loadWarehouseData({ id: transferInfo.warehouse_id })
    },
    loadSettlementInfo (data) {
      const settlementInfo = data.settlement_info
      if (settlementInfo.settlement_volume in [1, 2, 3, 4, 5]) {
        this.data.settlement_volume = settlementInfo.settlement_volume + ''
      }
      this.handleTradeSettlementVolumeChange(settlementInfo.settlement_volume)
      if (settlementInfo.settlement_volume === 5) {
        this.data.custom_settlement_volume = settlementInfo.custom_settlement_volume
      }
    },
    setPricingData (pricingData) {
      this.data = { ...this.data, ...pricingData }
      this.loadEditInfo(this.data)
    },
    loadPricingByType (data) {
      const parameter = { sell_contract_id: data.id, unit_price_type: data.unit_price_type }
      if (data.unit_price_type === 1) {
        sell_contract_fixed_pricing_list(parameter).then(res => {
          if (res.code === 1000 && res.data.entries !== undefined && res.data.entries.length > 0) {
            this.setPricingData(res.data.entries[0])
          } else {
            this.loadEditInfo(data)
          }
        })
      } else if (data.unit_price_type === 2) {
        sell_contract_point_pricing_list(parameter).then(res => {
          if (res.code === 1000 && res.data.entries !== undefined && res.data.entries.length > 0) {
            this.setPricingData(res.data.entries[0])
          } else {
            this.loadEditInfo(data)
          }
        })
      } else if (data.unit_price_type === 3) {
        sell_contract_floating_pricing_list(parameter).then(res => {
          if (res.code === 1000 && res.data.entries !== undefined && res.data.entries.length > 0) {
            this.setPricingData(res.data.entries[0])
          } else {
            this.loadEditInfo(data)
          }
        })
      } else {
        this.loadEditInfo(data)
      }
    },
    handleClientSearch (value) {
      project_client_list({ name: value, project_id: this.data.project_id }).then((res) => {
        const result = res.data.entries || []
        this.clientList = result
      })
    },
    loadContractAttachment () {
      sell_contract_attachment_list({ sell_contract_id: this.model['id'] }).then(res => {
           if (res.code === 1000 && res.data.entries) {
             this.otherData.attachment = res.data.entries
           }
        })
    },
    loadWarehouseData (params) {
      this.warehouseFetching = true
      this.tradeWarehouseList = []
      warehouse_list(params).then((res) => {
        this.tradeWarehouseList = res.data.entries || []
      }).finally(() => {
        this.warehouseFetching = false
      })
    },
    handleTradeSettlementVolumeChange (v) {
      const key = Number(v)
      this.settlementVolume = key
      const tradeSettlementVolumeContent = { 1: '毛重, 净重, 毛桶, 净桶', 2: '毛重, 净重, 毛桶, 净桶', 3: '毛重, 净重, 毛桶, 净桶', 4: '毛重, 净重' }
      if (key in tradeSettlementVolumeContent) {
        this.settlementVolumeContent = tradeSettlementVolumeContent[key].split(',')
        this.customSettlementVolumeContent = []
      } else {
        this.settlementVolumeContent = []
        this.customSettlementVolumeContent = []
      }
    },
    loadFormData (data) {
      this.selectedUnitPrice = data.unit_price_type
      this.selectedExchangeRate = data.exchange_rate_type
      this.paymentMethod = data.payment_method
      if (this.balancePaymentMethodKeys.includes(data.balance_payment_method)) {
        this.balancePaymentMethod = data.balance_payment_method
      }
      this.tradeBalancePaymentTimeMethod = data.trade_balance_payment_date_method
      this.settlementVolume = data.settlement_info.settlement_volume
      if (data.settlement_info.settlement_volume === 5) {
        this.settlementVolumeContent = []
        this.customSettlementVolumeContent = data.settlement_info.settlement_volume_content !== undefined ? data.settlement_info.settlement_volume_content.split(',') : ''
        if (this.customSettlementVolumeContent) {
          this.customSettlementVolumeContent = this.customSettlementVolumeContent.map(item => {
            const content = {
              name: item,
              key: this.randomNumber()
            }
            return content
          })
        }
      } else {
        this.customSettlementVolumeContent = []
        this.settlementVolumeContent = data.settlement_info.settlement_volume_content !== undefined ? data.settlement_info.settlement_volume_content.split(',') : ''
      }
      this.isTurningMonth = data.unit_price_type === 2 && data['futures_contract_list'] !== undefined && data['futures_contract_list'].length > 1
      this.pricingCurrency = data.pricing_currency
      this.prePayment = data.pre_payment
      this.balancePayment = data.balance_payment
      this.otherData.product_parameters = data.product_parameter_list
    },
    normalizeDate (date_str) {
      if (date_str === '1970-01-01' || date_str === '' || date_str === null) {
        return undefined
      }
      return date_str
    },
    loadEditInfo (data) {
      this.loadFormData(data)
      data.contract_date = this.normalizeDate(data.contract_date)
      data.pre_payment_date = this.normalizeDate(data.pre_payment_date)
      data.latest_delivery_date = this.normalizeDate(data.latest_delivery_date)
      if (data['futures_contract_list'] !== undefined && data['futures_contract_list'].length > 0) {
        this.otherData.turning_month_list = data['futures_contract_list']
      }
    },
    randomNumber () {
      const current_date = new Date()
      const random = Math.floor(Math.random() * 100000)
      return current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds() + '' + random
    },
    handleAddCancel () {
      this.visibleFrom = false
      this.mdl = {}
      const form = this.$refs[this.currentComponent].form
      form.resetFields() // 清理表单数据（可不做）
    },
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    },
    addTurningMonth (v) {
      if (!v) {
        this.otherData.turning_month_list = []
      }
      this.currentComponent = 'TurningMonthForm'
      this.mdl['size'] = this.otherData.turning_month_list.length
      this.visibleFrom = v
    },
    onDeleteItem (key) {
      const dataSource = [...this.otherData.turning_month_list]
      this.otherData.turning_month_list = dataSource.filter(item => item.key !== key)
      if (this.otherData.turning_month_list.length === 0) {
        this.form.setFieldsValue({ is_turning_month: false })
      }
    },
    handleOk (data) {
      const form = this.$refs[this.currentComponent].form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, data)
          // 新增
          if (this.currentComponent === 'KeyPointCreateForm') {
            values.keys = this.randomNumber()
            this.otherData.key_point.push(values)
          } else if (this.currentComponent === 'AttachmentCreateForm') {
            values.url = values.url.fileList[0].url
            values.key = this.randomNumber()
            this.otherData.attachment.push(values)
          } else if (this.currentComponent === 'TurningMonthForm') {
            const start_date = values['pricing_period'][0].format('YYYY-MM-DD')
            const end_date = values['pricing_period'][1].format('YYYY-MM-DD')
            values['pricing_period'] = undefined
            values['pricing_period_start_date'] = start_date
            values['pricing_period_end_date'] = end_date
            values.key = this.randomNumber()
            this.otherData.turning_month_list.push(values)
            form.resetFields()
          } else if (this.currentComponent === 'CreateProductParameterForm') {
            this.otherData.product_parameters = this.composeData(data, this.otherData.product_parameters)
          }
          this.visibleFrom = false
          form.resetFields()
        } else {
          this.confirmLoading = false
        }
      })
    },
    composeData (newList, oldList) {
      if (oldList === undefined || oldList.length === 0) {
        return newList
      } else {
        const seen = new Set()
        newList.forEach(item => {
          if (item.name) {
            seen.add(item.name)
          }
        })
        const filteredOldList = oldList.filter(item => item.name && !seen.has(item.name))
        return [...filteredOldList, ...newList]
      }
    },
    unitPriceChange (v) {
      if (v !== undefined) {
        this.selectedUnitPrice = Number(v)
      } else {
        this.selectedUnitPrice = 0
      }
      this.otherData.turning_month_list = []
      this.form.setFieldsValue({ is_turning_month: false })
    },
    handleTurningMonthChange (v) {
      this.isTurningMonth = v
    },
    exchangeRateChange (v) {
      if (v !== undefined) {
        this.selectedExchangeRate = Number(v)
      } else {
        this.selectedExchangeRate = 0
      }
    },
    isTempUnitPriceChange (v) {
      if (v !== undefined) {
        this.isSelectedTempUnitPrice = Number(v)
      } else {
        this.isSelectedTempUnitPrice = 0
      }
    },
    isTempExchangeRateChange (v) {
      if (v !== undefined) {
        this.isSelectedTempExchangeRate = Number(v)
      } else {
        this.isSelectedTempExchangeRate = 0
      }
    },
    paymentMethodChange (v) {
      if (v !== undefined) {
        this.paymentMethod = Number(v)
      } else {
        this.paymentMethod = 0
      }
    },
    isTempContractAmountChange (v) {
      if (v !== undefined) {
        this.isSelectedTempContractAmount = Number(v)
      } else {
        this.isSelectedTempContractAmount = 0
      }
    },
    balancePaymentMethodChange (v) {
      if (v !== undefined) {
        this.balancePaymentMethod = Number(v)
      } else {
        this.balancePaymentMethod = 6
      }
    },
    time (dates, dateStrings) {
      // this.param.start_date = dateStrings[0]
      // this.param.end_date = dateStrings[1]
    },
    productNameChange (e) {
      const new_product_name = e.target.value
      if (new_product_name !== this.data.product_name) {
        this.otherData.product_parameters = []
      } else {
        this.otherData.product_parameters = this.data.product_parameter_list
      }
    },
    addProductParameter (product_parameter_list) {
      // this.$router.push({ path: '/trade/' + record.id + '/product_parameter', query: { name: record.name } })
      this.currentComponent = 'CreateProductParameterForm'
      const product_name = this.form.getFieldValue('product_name')
      if (product_name !== this.data.product_name) {
        this.mdl['product_parameter_list'] = this.otherData.product_parameters
      } else {
        this.mdl['product_parameter_list'] = product_parameter_list
      }
      this.mdl['name'] = product_name
      this.visibleFrom = true
    },
    onParameterDelete (id) {
      this.otherData.product_parameters = this.otherData.product_parameters.filter(product => {
        return product.id !== id
      })
    },
    prePaymentChange (value) {
      this.prePayment = value
    },
    balancePaymentChange (value) {
      this.balancePayment = value
    },
    pricingCurrencyChange (value) {
      this.pricingCurrency = value
    },
    receivePricingCurrencyChange (value) {
      this.receivePricingCurrency = value
    }
  }
}
</script>
<style scoped>
.hidden_item {
  border: 1px solid #eeeeee;
  background-color: #efefef6a;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
</style>
